import { render, staticRenderFns } from "./Courier.vue?vue&type=template&id=45b96679&"
import script from "./Courier.vue?vue&type=script&lang=js&"
export * from "./Courier.vue?vue&type=script&lang=js&"
import style0 from "./Courier.vue?vue&type=style&index=0&id=45b96679&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports